





























































import {
  Vue,
  Component
} from "@/shared/vuepack";
import { openUrl } from "@/shared/urlHelper";

@Component({
  components: {}
})
export default class AvidiaForms extends Vue {
  AllegacyResourcesUrl = "https://www.allegacy.org/disclosures/";

  clickLink (event) {
    openUrl(event.currentTarget.href);
  }
}
